import { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import EventEmitter, {
  DISABLE_BLOCK_NAVIGATION,
} from '../../../helpers/EventEmitter'
import { localStorageKeys } from '../../../utils/common'
import { Element } from '../../html/element'
import { PopupAction } from '../PopupAction'
import { CountDown } from './CountDown'
import './i18n'
import { changeIsShow, selectIsShow } from './slice'

export const PopupSessionExpired = () => {
  const dispatch = useDispatch()
  const ref = useRef({})
  const isShow = useSelector(selectIsShow)

  const handleClose = () => {
    dispatch(changeIsShow(false))
    removeIntervalAndTimeOut()
  }

  const removeIntervalAndTimeOut = () => {
    localStorage.removeItem(localStorageKeys.KEY_START_TIME_SESSION_EXPIRED)

    if (ref.current.interval) {
      clearInterval(ref.current.interval)
      ref.current.interval = null
    }

    if (ref.current.timeOut) {
      clearTimeout(ref.current.timeOut)
      ref.current.timeOut = null
    }
  }

  useEffect(() => {
    EventEmitter.dispatch(DISABLE_BLOCK_NAVIGATION, isShow)
  }, [isShow])

  return (
    <PopupAction
      appendStyle={{
        backgroundColor: '#FFFFFF',
        borderRadius: 4,
        padding: 20,
        width: 480,
      }}
      isShow={isShow}
      btnSubmit={{
        label: 'common.CLOSE',
        isI18n: true,
        event: handleClose,
      }}
      footerStyle={{ justifyContent: 'center' }}
      handleClose={handleClose}
    >
      <div className="textCenter">
        <Element
          elementName="span"
          className="fw500"
          style={{ color: '#0553A5', fontSize: 20 }}
        >
          <Translate value="common.popup.sessionExpired.TITLE" />
        </Element>
      </div>

      <CountDown
        parentRef={ref}
        removeIntervalAndTimeOut={removeIntervalAndTimeOut}
      />
    </PopupAction>
  )
}
